export const profileButtonsWrapper = {
  margin: "1rem 1rem 2rem 1rem",
};

export const profilePictureStyle = {
  borderRadius: "50%",
  marginBottom: "2rem",
};

export const profileContentStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  minHeight: "90vh",
  padding: "5rem 1rem",
};

export const githubButtonStyle = {
  backgroundColor: "#238636",
  margin: "1rem 1rem",
  "&:hover": {
    backgroundColor: "#238636",
  },
  "&:active": {
    backgroundColor: "#238636",
  },
  "&:focus": {
    backgroundColor: "#238636",
  },
};

export const cvButtonStyle = {
  backgroundColor: "#323B4C",
  margin: "1rem 1rem",
  "&:hover": {
    backgroundColor: "#323B4C",
  },
  "&:active": {
    backgroundColor: "#323B4C",
  },
  "&:focus": {
    backgroundColor: "#323B4C",
  },
};

export const linkedInButtonStyle = {
  backgroundColor: "#0B66C2",
  margin: "1rem 1rem",
  "&:hover": {
    backgroundColor: "#0B66C2",
  },
  "&:active": {
    backgroundColor: "#0B66C2",
  },
  "&:focus": {
    backgroundColor: "#0B66C2",
  },
};
